import React, { useState } from 'react'

import {
  Checkboard,
  ColorPicker,
  InfoTooltip,
  Popper,
  useMediaQueryContext,
  withFormikSupport,
} from '@fourthwall/components'

import * as S from './ColorSelection.styled'
import type { Props } from './types'

const ColorSelectionComponent = ({ label, value, info, onChange, onBlur }: Props) => {
  const media = useMediaQueryContext()
  const [isOpen, setOpen] = useState(false)

  const handleBlur = () => {
    if (isOpen && onBlur && value) {
      onBlur({ color: value, isVariableUpdated: false })
    }
  }

  const toggleOpen = () => {
    handleBlur()

    setOpen((prevIsOpen) => {
      return !prevIsOpen
    })
  }

  const handleChange = (color: string) => {
    if (onChange) {
      onChange(color)
    }
  }

  return (
    <S.Container>
      <Popper
        isOpen={isOpen}
        referenceComponent={
          <S.PreviewContainer data-testid="ColorSelection.PreviewContainer" onClick={toggleOpen}>
            <Checkboard />
            <S.Preview
              style={{ backgroundColor: value }}
              $withBorder
              data-testid="ColorSelection.Preview"
            />
          </S.PreviewContainer>
        }
        popperProps={{
          placement: 'bottom-start',
        }}
        style={media.tablet ? { paddingTop: 12 } : undefined}
        onClose={() => {
          handleBlur()
          setOpen(false)
        }}
      >
        <ColorPicker
          color={value || '#000000'}
          format="HEX"
          hexVisible
          onValueChange={handleChange}
        />
      </Popper>
      <div>
        <S.Label>
          {label}
          <InfoTooltip content={info} />
        </S.Label>
        <S.Value>{value}</S.Value>
      </div>
    </S.Container>
  )
}

export const ColorSelection = withFormikSupport(ColorSelectionComponent)
